module.exports = __webpack_public_path__ + "img/search-hero-overflow-ford.a4e0811c.png";